import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_map_object as t } from "./map_object.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/values.js
var n = /* @__PURE__ */ e(((e, n) => {
	var r = t();
	n.exports = function(e) {
		return r(e, function(e, t) {
			return e;
		});
	};
}));
//#endregion
export default n();
export { n as require_values };
